import BaseProxy from './Proxy';

export default class SubstoreOrderOverviewProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/order', parameters);
  }

  find(context) {
    return this.submit('get', `${this.endpoint}/list/${context}`);
  }

  history(subscriberIdentifierType, uniqueOrderId) {
    return this.submit('get', `${this.endpoint}/history/${subscriberIdentifierType}/${uniqueOrderId}`);
  }

  cancel(uniqueOrderID) {
    return this.submit('post', `${this.endpoint}/cancel/${uniqueOrderID}`);
  }
}
